/* eslint-disable react/display-name */
import { makeStyles } from '@mui/styles';
import Checkbox from 'apollo-react/components/Checkbox';
import Tooltip from 'apollo-react/components/Tooltip';
import React from 'react';

const useStyles = makeStyles({
  tooltipContainer: {
    left: '-15px',
  },
  hiddenTooltipContainer: {
    display: 'none',
  },
});

const MultiSelectCell = (
  selections,
  handleSelect,
  shouldBeDisabled = () => {},
  shouldTooltipBeDisplayed = () => {},
  titleText = () => {}
) => {
  const classes = useStyles();

  return ({ row }) => {
    const checked =
      selections.find((s) =>
        Boolean(row.PrimaryKeyColumn) && Boolean(s.PrimaryKeyColumn)
          ? s[s.PrimaryKeyColumn] === row[row.PrimaryKeyColumn]
          : JSON.stringify(s) === JSON.stringify(row)
      ) !== undefined;

    return (
      <Tooltip
        title={titleText(row) || ''}
        placement="top"
        classes={{
          tooltip: shouldTooltipBeDisplayed(row)
            ? classes.tooltipContainer
            : classes.hiddenTooltipContainer,
        }}
      >
        <span>
          <Checkbox
            disabled={shouldBeDisabled(row)}
            checked={checked}
            onChange={(e, _checked) => handleSelect(_checked, row)}
            aria-label="Multi Select Cell"
          />
        </span>
      </Tooltip>
    );
  };
};

export default MultiSelectCell;
